module.exports = __webpack_public_path__ + "static/francesco_kovacs-d7ebf576390cb2c114adb0dac6aea0f6.jpg";